const  isPro = Object.is(process.env.NODE_ENV, 'production')
module.exports= {
    baseUrl: isPro ? 'http://192.168.31.192:8084/':'api/'
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 45